import React from 'react';

export type MaiPriority = 'high' | 'normal' | 'low';

export type MaiActionCardProps = {
  title: string;
  detail?: string | null;
  priority?: MaiPriority | null;
  pills?: Array<{ label: string; tone?: 'high' | 'you' | 'wait' | 'ai' | 'default' }>;
  primaryLabel?: string | null;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  secondaryLabel?: string | null;
  onSecondary?: () => void;
  secondaryDisabled?: boolean;
  /** Terceira ação (ex.: Rejeitar em decisões HJ-01). */
  tertiaryLabel?: string | null;
  onTertiary?: () => void;
  tertiaryDisabled?: boolean;
  /** Classe extra no botão terciário (ex.: rejeitar). */
  tertiaryClassName?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
};

export const MaiActionCard: React.FC<MaiActionCardProps> = ({
  title,
  detail,
  priority,
  pills,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  secondaryDisabled,
  tertiaryLabel,
  onTertiary,
  tertiaryDisabled,
  tertiaryClassName,
  onClick,
  children,
  className,
}) => {
  const tonePills = pills?.length
    ? pills
    : priority === 'high'
      ? [{ label: 'urgente', tone: 'high' as const }]
      : [];

  const hasCtas = !!(primaryLabel || secondaryLabel || tertiaryLabel);

  return (
    <div
      className={`mai-card mai-action-card ${onClick ? 'is-clickable' : ''} ${className || ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
    >
      <div className="mai-card-row">
        <div className="mai-action-card-body">
          {(tonePills.length > 0) && (
            <div className="mai-action-card-pills">
              {tonePills.map((p) => (
                <span
                  key={p.label}
                  className={`mai-pill ${
                    p.tone === 'high' ? 'mai-pill-high'
                      : p.tone === 'you' ? 'mai-pill-you'
                        : p.tone === 'wait' ? 'mai-pill-wait'
                          : p.tone === 'ai' ? 'mai-pill-ai'
                            : ''
                  }`}
                >
                  {p.label}
                </span>
              ))}
            </div>
          )}
          <p className="mai-card-title">{title}</p>
          {detail ? <p className="mai-card-detail">{detail}</p> : null}
          {children}
        </div>
        {hasCtas && (
          <div className="mai-action-card-ctas" onClick={(e) => e.stopPropagation()}>
            {primaryLabel && onPrimary && (
              <button type="button" className="mai-btn" onClick={onPrimary} disabled={primaryDisabled}>
                {primaryLabel}
              </button>
            )}
            {secondaryLabel && onSecondary && (
              <button type="button" className="mai-btn mai-btn-soft" onClick={onSecondary} disabled={secondaryDisabled}>
                {secondaryLabel}
              </button>
            )}
            {tertiaryLabel && onTertiary && (
              <button
                type="button"
                className={`mai-btn mai-btn-ghost ${tertiaryClassName || ''}`.trim()}
                onClick={onTertiary}
                disabled={tertiaryDisabled}
              >
                {tertiaryLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MaiActionCard;
